import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { PromoCmsComponents } from '@core/const';
import { SdSwiperComponent } from '@sdvor/shared/ui';
import { CmsConfig, provideDefaultConfig } from '@spartacus/core';
import { MediaModule, PageComponentModule } from '@spartacus/storefront';
import { SdBannerCarouselPeekComponent } from './banner-carousel-peek.component';

@NgModule({
  imports: [NgIf, NgFor, AsyncPipe, SdSwiperComponent, MediaModule, PageComponentModule],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        [PromoCmsComponents.RosaFormattedResponsiveBannerOneLineCarouselComponent]: {
          component: SdBannerCarouselPeekComponent,
        },
      },
    }),
  ],
  declarations: [SdBannerCarouselPeekComponent],
})
export class SdBannerCarouselPeekModule {}
